import { Box, Link, ModuleBase, ResponsiveImage, Stack } from '@/components';
import { ExpertsListingModuleModel } from './ExpertsListingModule';
import { useTranslations } from 'next-intl';
import { animControllerInView, fadeIn } from '@/animations';

const ExpertsListingModuleGrid = (data: ExpertsListingModuleModel) => {
  const { experts } = data.props;
  const t = useTranslations();

  return (
    <ModuleBase data={data} className="lg:py-18">
      <div className="container flex flex-wrap xl:px-40">
        {experts &&
          experts.map((expert, index) => (
            <Stack
              key={index}
              animation={animControllerInView({ amount: 0.4 })}
              className="flex w-full p-3 md:w-1/2 lg:w-1/3 lg:p-5 lg:py-10"
            >
              <Box animation={fadeIn} className="relative flex w-full flex-col">
                <div className="aspect-[366/487]">
                  {expert.image && (
                    <ResponsiveImage
                      image={expert.image}
                      widths={{ xs: 158, sm: 260, md: 260, lg: 366, xl: 366 }}
                      heights={{ xs: 210, sm: 346, md: 346, lg: 487, xl: 487 }}
                    />
                  )}
                </div>
                <div className="bg-gray-2 -mt-14 flex w-10/12 flex-grow flex-col gap-2 self-end p-5">
                  <h2 className="text-style-h4">{expert.expertName}</h2>
                  <p className="text-style-h5 !text-[16px] leading-[18px] lg:!text-[22px] lg:!leading-[24px]">
                    {expert.jobTitle}
                  </p>
                  {expert.landingPageLink && (
                    <div className="mt-2">
                      <Link className="btn v2 underline" link={expert.landingPageLink}>
                        {t('general.$viewBio')}
                      </Link>
                    </div>
                  )}
                </div>
              </Box>
            </Stack>
          ))}
      </div>
    </ModuleBase>
  );
};

export default ExpertsListingModuleGrid;
